import CloseIcon from '@mui/icons-material/Close';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useRecordContext } from 'react-admin';
import { Button } from 'shared/mui/Buttons';
import { Card, CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { IconButton } from 'shared/mui/IconButtons';
import { Mapping } from 'types/embedded/gatewayRule';

type Props = {
  onConfirm: () => void;
  onClose: () => void;
} & DialogProps;

export const GatewayRuleMappingToggleConfirm: React.FC<Props> = ({ onConfirm, onClose, open }) => {
  const translate = useTypedTranslate();
  const record = useRecordContext<Mapping>();

  return (
    <Dialog onClose={onClose} open={open}>
      <Card>
        <CardHeader
          appendActions={[
            <IconButton aria-label="close" key="close-button" onClick={onClose}>
              <CloseIcon />
            </IconButton>,
          ]}
          title={
            record?.active
              ? translate('app.gatewayRules.disableMethod')
              : translate('app.gatewayRules.enableMethod')
          }
          titleSize="smallBold"
        />
        <CardContent sx={{ width: '552px' }}>
          {record?.active
            ? translate('app.gatewayRules.disableMethodMessage', {
                methodName: record?.method?.name,
                gatewayRuleName: record?.gatewayRule?.name,
              })
            : `${translate('app.gatewayRules.enableMethodMessage', {
                methodName: record?.method?.name,
                gatewayRuleName: record?.gatewayRule?.name,
              })} `}
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={[
            <Button
              key="cancel-button"
              label={translate('app.buttons.cancel')}
              onClick={onClose}
              variant="outlined"
            />,
            <Button
              key="confirm-button"
              label={translate('app.buttons.approve')}
              onClick={() => {
                onConfirm();
                onClose();
              }}
              variant="contained"
            />,
          ]}
        />
      </Card>
    </Dialog>
  );
};
